// extracted by mini-css-extract-plugin
export default {"mainCatalog_wrapper":"ForkliftCards_mainCatalog_wrapper__9EXGE"};